/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Toast_Gpx_Import_Success_OtherInputs */

const en_toast_gpx_import_success_other = /** @type {(inputs: Toast_Gpx_Import_Success_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} routes imported`)
};

const de_toast_gpx_import_success_other = /** @type {(inputs: Toast_Gpx_Import_Success_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Routen importiert`)
};

/**
* | output |
* | --- |
* | "{count} routes imported" |
*
* @param {Toast_Gpx_Import_Success_OtherInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const toast_gpx_import_success_other = /** @type {((inputs: Toast_Gpx_Import_Success_OtherInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Gpx_Import_Success_OtherInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toast_gpx_import_success_other(inputs)
	return de_toast_gpx_import_success_other(inputs)
});